// document.addEventListener('DOMContentLoaded', () => {
//   const output = document.querySelector('.beard-preview-summary');
//   const info = document.querySelector('.product__info-container');
//   if (!output || !info) return;
//   const money = new Intl.NumberFormat('en-IN', {style: 'currency', currency: 'INR', maximumFractionDigits: 2});
//   function update() {
//     const input = info.querySelector('.latest-variantgrid input:checked');
//     const label = input && document.querySelector('label[for="' + input.id + '"]');
//     if (!label) return;
//     const price = Number(label.querySelector('.vcard-price')?.textContent.replace(/[^0-9.]/g, ''));
//     const prepaid = label.querySelector('.vcard-prepaid-price')?.textContent.trim();
//     if (!Number.isFinite(price) || !prepaid) return;
//     const quantity = Number(info.querySelector('.product-form__buttons-row input[name="quantity"]')?.value || 1);
//     const online = Number(prepaid.replace(/[^0-9.]/g, ''));
//     const prefix = quantity > 1 ? quantity + ' × ' : '';
//     output.textContent = prefix + input.value + ' · Prepaid ' + money.format(online * quantity) + ' · COD ' + money.format(price * quantity) + ' + applicable fee';
//   }
//   info.addEventListener('change', update);
//   info.addEventListener('input', update);
//   new MutationObserver(update).observe(info, {childList: true, subtree: true});
//   update();
// });


document.addEventListener('DOMContentLoaded', () => {
  const output = document.querySelector('.beard-preview-summary');
  const info = document.querySelector('.product__info-container');
  if (!output || !info) return;

  const money = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  // Text me se pehla ₹ amount nikalo (commas handle karta hai)
  const firstAmount = (txt) => {
    const m = String(txt || '').match(/₹\s*([\d,]+(?:\.\d+)?)/) || String(txt || '').match(/([\d,]+(?:\.\d+)?)/);
    return m ? Number(m[1].replace(/,/g, '')) : 0;
  };

  function update() {
    const input = info.querySelector('.latest-variantgrid input:checked');
    const label = input && document.querySelector('label[for="' + input.id + '"]');
    if (!label) return;

    const price = firstAmount(label.querySelector('.vcard-price')?.textContent);
    const prepaidTxt = label.querySelector('.vcard-prepaid-price')?.textContent || '';
    if (!price) return;

    // 1) Text me "12%" likha hai to wahi use karo
    let percent = 0;
    const pctMatch = prepaidTxt.match(/(\d+(?:\.\d+)?)\s*%/);
    if (pctMatch) {
      percent = Math.round(Number(pctMatch[1]));
    } else {
      // 2) Warna prepaid ₹ amount se calculate karo
      const online = firstAmount(prepaidTxt);
      if (online > 0 && online < price) percent = Math.round(((price - online) / price) * 100);
    }

    // 3) Safety: galat value aaye to 12% fallback
    if (!percent || percent <= 0 || percent >= 90) percent = 12;

    const quantity = Math.max(1, Number(info.querySelector('.product-form__buttons-row input[name="quantity"]')?.value || 1));
    const variantText = input.value + (quantity > 1 ? ' x' + quantity : '');
    const text = variantText + ' · Prepaid ' + percent + '% OFF · COD ' + money.format(price * quantity) + ' + applicable fee';

    if (output.textContent !== text) output.textContent = text;
  }

  info.addEventListener('change', update);
  info.addEventListener('input', update);
  info.addEventListener('click', () => setTimeout(update, 50));
  new MutationObserver(update).observe(info, { childList: true, subtree: true });
  update();
});